import PageHeader from '../components/PageHeader';
import Footer from '../components/Footer';
import OrderStatus from '../components/OrderStatus';

import sand from '../images/sanf.jpg';
import { useState } from 'react';

export default function FoodList() {
    const images = [sand, sand, sand, sand, sand];  // Array of images
    const [isLightboxOpen, setIsLightboxOpen] = useState(false);
    const [currentImage, setCurrentImage] = useState('');
    const [currentIndex, setCurrentIndex] = useState(0);

    const openLightbox = (index) => {
        setCurrentImage(images[index]);
        setCurrentIndex(index);
        setIsLightboxOpen(true);
    };

    const closeLightbox = () => {
        setIsLightboxOpen(false);
    };

    const goToNextImage = () => {
        const nextIndex = (currentIndex + 1) % images.length;  // Loop back to the first image
        setCurrentImage(images[nextIndex]);
        setCurrentIndex(nextIndex);
    };

    const goToPreviousImage = () => {
        const prevIndex = (currentIndex - 1 + images.length) % images.length;  // Loop back to the last image
        setCurrentImage(images[prevIndex]);
        setCurrentIndex(prevIndex);
    };

    return (
        <div className="container-fluid p-0 mt-4 mb-0">
            <PageHeader />

            <div className="container">
                {/* breadcrumb */}
                <div className="row">
                    <div className="col-12">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                <li className="breadcrumb-item"><a href="/menu">View Menu</a></li>
                                <li className="breadcrumb-item"><a href="/menu-sub">Foods</a></li>
                                <li className="breadcrumb-item active" aria-current="page">Sandwiches</li>
                            </ol>
                        </nav>
                    </div>
                </div>
                {/* breadcrumb */}

                {/* order status box */}
                <div className="row">
                    <OrderStatus />
                </div>
                {/* order status box */}

                {/* Food Item Cards */}
                {['item1', 'item2', 'item3', 'item4', 'item5'].map((item, index) => (
                    <div key={index} className="bg-white mb-4 p-3 rounded-3">
                        <div className="d-flex mb-3 gap-1" style={{ width: '300px', overflowX: 'auto', whiteSpace: 'nowrap' }}>
                            {[...Array(5)].map((_, idx) => (
                                <div key={idx} onClick={() => openLightbox(idx)} style={{ cursor: 'pointer' }}>
                                    <img src={sand} alt={`sandwich-${idx}`} className="d-block rounded" style={{ width: '100px', display: 'inline-block' }} />
                                </div>
                            ))}
                        </div>
                        <h2 className="ol_li mb-0" style={{ paddingLeft: '0px !important' }}>Smoked Chicken Sandwiches</h2>
                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been</p>
                        <h1 className="main_heading mb-0">RS.790.00</h1>
                    </div>
                ))}

                {/* Lightbox Modal */}
                {isLightboxOpen && (
                    <div className="lightbox-overlay" onClick={closeLightbox}>
                        <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
                            <img src={currentImage} alt="Lightbox Image" className="lightbox-image" />
                            <div className="lightbox-navigation">
                                <button className="lightbox-prev" onClick={goToPreviousImage}>&lt;</button>
                                <button className="lightbox-next" onClick={goToNextImage}>&gt;</button>
                            </div>
                            <span className="lightbox-close" onClick={closeLightbox}>×</span>
                        </div>
                    </div>
                )}
            </div>

            <Footer />
        </div>
    );
}
